import { Injectable } from '@angular/core';
// crypto-js 走子路徑 import。
//
// 從套件根目錄 import（無論 `import * as` 或具名 import）都會帶進整包 ——
// 實測首屏含 36 個 crypto-js 檔、69.1 KB，其中 blowfish 12.5 KB、tripledes 10.3 KB
// 以及各式 SHA / rabbit / rc4 / pbkdf2 全部沒被用到。crypto-js 是 CommonJS，
// 無法靠 tree-shaking 消除，只能靠子路徑限制載入範圍。
//
// mode.CBC 是唯一沒有獨立子模組的相依（定義在 cipher-core 內），因此改由
// `crypto-js/core` 取得 —— 它匯出的是與各子模組共用的同一個 CryptoJS singleton，
// 而 `crypto-js/aes` 已經拉入 cipher-core 完成註冊。
// 取用點都在方法內而非 module 頂層，故不受載入順序影響。
import AES from 'crypto-js/aes';
import CryptoJS from 'crypto-js/core';
import Utf8 from 'crypto-js/enc-utf8';
import ECB from 'crypto-js/mode-ecb';
import Pkcs7 from 'crypto-js/pad-pkcs7';
import { environment } from 'src/environments/environment';

const secretKey = 'fAznjeRFoRe8d5VG';

@Injectable({
  providedIn: 'root',
})
export class EncryptService {
  constructor() {}

  encrypt(content: string, rsaPublicKey: string = environment.rsaPublicKey): string {
    //@ts-ignore
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(rsaPublicKey);
    return encryptor.encrypt(content).toString();
  }
  encryptLong(content: string, rsaPublicKey: string = environment.rsaPublicKey): string {
    //@ts-ignore
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(rsaPublicKey);
    return encryptor.encryptLong(content).toString();
  }

  encryptByDeAES(data: string): string {
    const Key = '123456';
    const tmpDeAES = AES.decrypt(data, Key, {
      mode: CryptoJS.mode.CBC,
      padding: Pkcs7,
    });
    return tmpDeAES.toString(Utf8);
  }

  aesEncrypt = (content: any) => {
    const key = Utf8.parse(secretKey); //处理密钥
    const srcs = Utf8.parse(content); //处理要加密的字符串
    const encrypted = AES.encrypt(srcs, key, { mode: ECB, padding: Pkcs7 });
    return encrypted.toString();
  };

  aesDecrypt(encryptStr: any) {
    const key = Utf8.parse(secretKey);
    const decrypt = AES.decrypt(encryptStr, key, { mode: ECB, padding: Pkcs7 });
    return Utf8.stringify(decrypt).toString();
  }
}
